import { useDefaultTableStyling as sytlingOptions } from "./globalStyle"
import { Strings } from '../assets/res/en'
export default function promotionDataColumn(groupsMenus) {
    let mapped = groupsMenus.map(item => ({ [item.val]: item.text }))
    let groupItems = Object.assign({}, ...mapped)
    const columns = [
        {
            title: Strings.COLUMN_GROUP, field: 'idGroup', lookup: groupItems,
            render: (rowdata) => rowdata.idGroup === 0 ? "No Group" : rowdata.groupDescription,
            disableClick: 'true', validate: rowData => (rowData.group && rowData.group !== '') ? true : false
        },
        {
            title: Strings.COLUMN_LOCATION, field: 'idMerchant', disableClick: 'true',
            render: (rowdata) => rowdata.idMerchant === 0 ? "No Location" : rowdata.merchantDescription,
        },
        { title: Strings.COLUMN_PROMOTION_TITLE_DETAILS, field: 'title', disableClick: 'true' },
        // { title: Strings.COLUMN_PROMOTION_DESCRIPTION, field: 'description', disableClick: 'true' },
        { title: Strings.COLUMN_PROMOTION_START, field: 'dateTimeStart', disableClick: 'true', type: 'datetime' },
        { title: Strings.COLUMN_PROMOTION_END, field: 'dateTimeEnd', disableClick: 'true', type: 'datetime' },
        { title: Strings.COLUMN_PROMOTION_PRIORITY, field: 'priority', disableClick: 'true' },
        //{ title: Strings.COLUMN_PROMOTION_PUSH, field: 'push', type: "boolean", disableClick: 'true' }
    ]
    return { columns, sytlingOptions }
}